import { useIsSuspendedQuery } from 'generated/graphql';

export const useIsSuspended = () => {
  const isSuspended = useIsSuspendedQuery();

  return Boolean(isSuspended.data?.me?.isSuspended);
};
